import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["bookmark", "savedCard", "cardCollection", "empty", "count", "toast", "dialog"]
  static values = { added: String, removed: String, save: String, saved: String, copied: String, copyFail: String, storageFail: String }

  connect() {
    this.storageKey = "xiaoxiao-saved-v1"
    try {
      const data = JSON.parse(localStorage.getItem(this.storageKey) || "[]")
      this.saved = new Set(Array.isArray(data) ? data.filter(value => typeof value === "string") : [])
    } catch { this.saved = new Set() }
    this.sync()
  }

  disconnect() { clearTimeout(this.toastTimer) }

  toggle(event) {
    event.preventDefault()
    const slug = event.currentTarget.dataset.slug
    const next = new Set(this.saved)
    if (next.has(slug)) next.delete(slug)
    else next.add(slug)
    try { localStorage.setItem(this.storageKey, JSON.stringify([...next])) }
    catch { this.notify(this.storageFailValue); return }
    this.saved = next
    this.sync()
    this.notify(this.saved.has(slug) ? this.addedValue : this.removedValue)
  }

  sync() {
    this.bookmarkTargets.forEach(button => {
      const active = this.saved.has(button.dataset.slug)
      button.classList.toggle("is-saved", active)
      button.setAttribute("aria-pressed", String(active))
      button.setAttribute("aria-label", active ? this.savedValue : this.saveValue)
      const label = button.querySelector("[data-bookmark-label]")
      if (label) label.textContent = active ? this.savedValue : this.saveValue
    })
    this.savedCardTargets.forEach(card => { card.hidden = !this.saved.has(card.dataset.slug) })
    const savedCardsPending = this.cardCollectionTargets.some(collection =>
      collection.dataset.guideCardsSavedPageValue === "true" && collection.dataset.state !== "ready")
    this.emptyTargets.forEach(empty => { empty.hidden = savedCardsPending || this.savedCardTargets.some(card => !card.hidden) })
    this.countTargets.forEach(count => { count.textContent = String(this.saved.size) })
  }

  async share() {
    try {
      await navigator.clipboard.writeText(window.location.href)
      this.notify(this.copiedValue)
    } catch { this.notify(this.copyFailValue) }
  }

  openAbout() { this.dialogTarget.showModal() }
  closeAbout() { this.dialogTarget.close() }
  backdrop(event) { if (event.target === this.dialogTarget) this.closeAbout() }

  notify(message) {
    clearTimeout(this.toastTimer)
    this.toastTarget.textContent = message
    this.toastTarget.hidden = false
    this.toastTimer = setTimeout(() => { this.toastTarget.hidden = true }, 3200)
  }
}
